export default __webpack_public_path__ + "static/media/userIcon.f1830e59.svg";